import React, {useContext, useMemo} from 'react';
import {Table} from 'antd';
import {PlayerContext} from '../../../../shared/contexts/playerContext';
import IsLoading from '../../../../shared/components/IsLoading';
import ErrorPage from '../../../../shared/components/ErrorPage';
import {useProfileData} from '../../../logs/useTableData';

const ProfileTable = ({title, rows, ownedIds}) => {
    const owned = useMemo(() => new Set((ownedIds || []).map(Number)), [ownedIds]);
    const dataSource = useMemo(
        () => (rows || []).map(row => ({...row, key: row.index, owned: owned.has(row.index)})),
        [rows, owned]
    );

    const columns = useMemo(() => [
        {title: '인덱스', dataIndex: 'index', width: 100},
        {title: '이름', dataIndex: 'name'},
        {
            title: '보유 여부',
            dataIndex: 'owned',
            width: 100,
            render: (isOwned) => (
                <span style={{color: isOwned ? '#52c41a' : '#ff4d4f', fontWeight: 600}}>
                    {isOwned ? '보유' : '미보유'}
                </span>
            ),
        },
    ], []);

    return (
        <div style={{flex: 1, minWidth: 320}}>
            <div style={{marginBottom: 8, fontWeight: 600}}>
                {title} ({dataSource.filter(r => r.owned).length} / {dataSource.length})
            </div>
            <Table
                size="small"
                bordered
                columns={columns}
                dataSource={dataSource}
                pagination={false}
                scroll={{y: 600}}
            />
        </div>
    );
};

const Profile = () => {
    const {playerData} = useContext(PlayerContext);
    const {data, isLoading, error} = useProfileData();

    if (isLoading) return <IsLoading/>;
    if (error) return <ErrorPage error={error}/>;

    const inventoryData = playerData.playerInfo?.inventoryData || {};

    return (
        <div style={{display: 'flex', gap: 24, alignItems: 'flex-start'}}>
            <ProfileTable
                title="프로필 이미지"
                rows={data?.profileImg}
                ownedIds={inventoryData.OwnedProfileImageIds}
            />
            <ProfileTable
                title="프로필 테두리"
                rows={data?.profileFrame}
                ownedIds={inventoryData.OwnedProfileFrameIds}
            />
        </div>
    );
};

export default Profile;
